import { render } from "./Paynemtfailure.vue?vue&type=template&id=69b72ac7&ts=true"
import script from "./Paynemtfailure.vue?vue&type=script&lang=ts"
export * from "./Paynemtfailure.vue?vue&type=script&lang=ts"

import "./Paynemtfailure.vue?vue&type=style&index=0&id=69b72ac7&lang=scss"

import exportComponent from "/Users/bekircankaya/Documents/GitHub/kurban-vekalet-frontend-eski-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__